import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { NotificationBell } from "./NotificationBell";
import { ChartLineUp, ChartPieSlice, UsersThree, Headset, Kanban, SignOut, Ticket, ChartBar, UserPlus, Briefcase, AddressBook } from "@phosphor-icons/react";

const nav = [
  { to: "/admin", label: "Overview", icon: ChartPieSlice, end: true },
  { to: "/admin/clients", label: "Clients", icon: UsersThree },
  { to: "/admin/agents", label: "Agents", icon: Headset },
  { to: "/admin/tasks", label: "Task Board", icon: Kanban },
  { to: "/admin/job-requests", label: "Job Requests", icon: Briefcase },
  { to: "/admin/tickets", label: "Ticket Center", icon: Ticket },
  { to: "/admin/reports", label: "Category Reports", icon: ChartBar },
  { to: "/admin/leads", label: "Leads", icon: UserPlus },
  { to: "/admin/team", label: "Team Directory", icon: AddressBook },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 shrink-0 bg-[#002FA7] text-white flex flex-col fixed h-screen">
        <div className="p-5 flex items-center gap-2 border-b border-white/15">
          <ChartLineUp size={24} weight="fill" color="#fff" />
          <span className="font-head font-black tracking-tight">VIRTUALEENA</span>
        </div>
        <div className="px-5 py-3 text-xs uppercase tracking-[0.2em] text-white/50">Admin Console</div>
        <nav className="flex-1 px-3 space-y-0.5">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`anav-${n.label.replace(/\s+/g, '-').toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${isActive ? "bg-white text-[#002FA7] font-semibold" : "text-white/75 hover:bg-white/10"}`}>
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/15">
          <div className="text-sm font-semibold truncate">{user?.name}</div>
          <div className="text-white/50 text-xs mb-3">Platform Admin</div>
          <button data-testid="logout-btn" onClick={doLogout} className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"><SignOut size={18} /> Sign out</button>
        </div>
      </aside>
      <div className="flex-1 ml-60">
        <header className="h-16 border-b border-black/10 bg-white/70 backdrop-blur-xl sticky top-0 z-20 flex items-center justify-between px-8">
          <p className="label">Virtualeena Team · Admin Portal</p>
          <NotificationBell tone="dark" />
        </header>
        <main className="p-8 max-w-[1400px]"><Outlet /></main>
      </div>
    </div>
  );
}
